<script lang="ts">
  import type { Snippet } from 'svelte';
  let { title, children }: { title: string; children: Snippet } = $props();
</script>

<section class="sblock">
  <div class="sh">{title}</div>
  <div class="sbb">{@render children()}</div>
</section>

<style>
  .sblock { border: 1px solid var(--border); border-radius: 9px; background: var(--bg-surface); margin-bottom: 10px; overflow: hidden; }
  .sh { padding: 9px 13px; background: var(--bg-hover); border-bottom: 1px solid var(--border); font-size: 14px; font-weight: 600; }
  .sbb { padding: 11px 13px; }
</style>
